import styled from "styled-components";
export const Container = styled.div`
  margin: 0 auto;
  background-color: #e5f5f2;
  border-radius: 20px;

  .main-div {
    background-color: white;
    border-radius: 20px;
    @media screen and (min-width: 768px) {
      height: calc(-100px + 100vh);
    }
  }
`;
export const ContentSection = styled.div`
  padding: 30px 16px;
  .joining-section {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    flex-direction: column;
    position: relative;
    .title {
      font-size: 14px;
      color: #142c1f;
      font-weight: 600;
    }
    .checkbox-row {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-top: 10px;
    }
    .checkbox-label {
      font-size: 14px;
      color: #525866;
    }
  }
`;
export const Title = styled.h3`
  color: #142c1f;
  font-size: 20px;
`;
export const Description = styled.p`
  color: #44554c;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 20px;
  text-align: justify;
  max-width: 900px;
`;
export const AwardSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  max-width: 550px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 13px 20px #d6d6d629;
  border: 1px solid #e2e4e9;
  border-radius: 12px;
  padding: 10px;
  justify-content: space-between;
  .amount {
    /* margin-top: 10px; */
  }
  .award-text {
    text-align: center;
  }
  .award-container {
    display: flex;
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    .award-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
    }
    .amount {
      /* margin-top: 10px; */
      text-align: right;
      margin-left: auto;
    }
  }

  .award-icon {
    width: 80px;
    height: 80px;
    margin-right: 10px;
  }
  .award-text {
    font-size: 16px;
    color: #142c1f;
  }
  .content-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;

    .title {
      color: #1c9d87;
      font-size: 12px;
    }
    .subtitle {
      color: #142c1f;
      font-weight: 500;
      font-size: 16px;
    }
    .description {
      color: #444444;
      font-size: 14px;
    }
  }
  .amount {
    color: #1c9d87;
    font-size: 28px;
  }
`;
export const Disclaimer = styled.p`
  color: #525866;
  font-size: 8px;
  margin-top: auto;
  flex-grow: 1;
  position: absolute;
  bottom: 70px;
  max-width: 1000px;
  @media screen and (max-width: 768px) {
    position: relative;
    margin-top: 100px;
    bottom: 0px;
  }
`;
